import { render } from "./WhatsappIconPage.vue?vue&type=template&id=2b660270&scoped=true"
import script from "./WhatsappIconPage.vue?vue&type=script&lang=js"
export * from "./WhatsappIconPage.vue?vue&type=script&lang=js"

import "./WhatsappIconPage.vue?vue&type=style&index=0&id=2b660270&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b660270"]])

export default __exports__